<div class="document-details">
  <div class="row m-0">
    <div class="col-sm-12 nav d-flex justify-content-between align-items-center doc-detail-nav">
      <a href="javascript:void(0)" (click)="onBackClick()" class="doc-back-link">
        <i class="fa fa-caret-left" aria-hidden="true"></i>
        <i class="fa fa-caret-left" aria-hidden="true"></i>
        {{ documentPdfOnlyMode ? 'Close' : 'Documents' }}
      </a>
      <span class="doc-detail-title" *ngIf="currentDocument?.title">{{ currentDocument.title }}</span>
    </div>
  </div>

  <div class="document-pdf-wrap" *ngIf="currentDocument?.FinalUrl">
    <div id="document-pdf-div" class="pdf-view" style="width:100% !important; height: 50em;"></div>
  </div>

  <div class="document-minute-vote px-3 pb-4"
    *ngIf="currentDocument?.minuteType && meetingIdForVote">
    <app-minute-vote-detail
      [meetingId]="meetingIdForVote"
      [minuteType]="currentDocument.minuteType"
      [allowVoting]="canVoteMinutes">
    </app-minute-vote-detail>
  </div>
</div>
